import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('security');

export const checkKey = (key) => {
  let permissions = environment.getUserPermissions();
  if(permissions !== null && permissions !== undefined && permissions.length > 0){
    if(permissions.includes(key)){
      return true;
    }
  }
  return useBasicAuth.redirectToDenied();
}

export const hasAccess = (key) => {
  let permissions = environment.getUserPermissions();
  if(permissions !== null && permissions !== undefined && permissions.length > 0){
    if(permissions.includes(key)){
      return true;
    }
  }
  return false;
}

export const checkGroup = (key) => {
  let groups = environment.getUserGroups();
  if(groups !== null && groups !== undefined && groups.length > 0){
    if(groups.includes(key)){
      return true;
    }
  }
  return useBasicAuth.redirectToDenied();
}

export const hasGroupAccess = (key) => {
  let groups = environment.getUserGroups();
  if(groups !== null && groups !== undefined && groups.length > 0){
    if(groups.includes(key)){
      return true;
    }
  }
  return false;
}

export const findAllPermissions = (userId) => 
  axios.get(urlAPI + "/getPermissions/" + userId , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

